import type { SVGProps } from 'react'
const SvgSyLoadCircle = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<circle r={6} fillOpacity={0.24} transform="matrix(0 -1 -1 0 12 14)" />
		<path d="M12 4.5a.5.5 0 0 0-.5.5v8.793l-1.646-1.647a.5.5 0 0 0-.708 0 .5.5 0 0 0 0 .708l2.5 2.5A.5.5 0 0 0 12 15.5a.5.5 0 0 0 .354-.146l2.5-2.5a.5.5 0 0 0 0-.708.5.5 0 0 0-.708 0L12.5 13.793V5a.5.5 0 0 0-.5-.5" />
	</svg>
)
export default SvgSyLoadCircle
